var render = function render(){var _vm=this,_c=_vm._self._c;return _c('after-sales',{attrs:{"type":"refund","after-sales-number":_vm.refundNumber,"refund-type":_vm.refundType}})
}
var staticRenderFns = []

export { render, staticRenderFns }